import getPropFromModule from './getPropFromModule';
import { DATA, PHONE_VERIFIED, SETTINGS } from '../model';

const getPhoneVerified = state =>
  getPropFromModule(state, DATA, SETTINGS, PHONE_VERIFIED);

export default getPhoneVerified;
